import { createWidget } from '@alfa-bank/site-util-create-widget/create-widget';

import { SectionLinkDesktop as SectionLink } from '../section-link/desktop';

import type { ISubSectionDeps, TSubSection } from './models';
import { SubSection as Component } from './sub-section';
import styles from './desktop.css';

export const SubSectionDesktop = createWidget<ISubSectionDeps, TSubSection>({
    SectionLink,
    styles,
})(Component);
